export const background = {
  default: 'rgb(250, 250, 250)',
  subtle: 'rgb(245, 245, 245)',
}
export const surface = {
  default: 'rgb(255, 255, 255)',
  raised: 'rgb(255, 255, 255)',
  sunken: 'rgb(245, 245, 245)',
}
export const text = {
  default: 'rgb(14, 17, 19)',
  muted: 'rgb(73, 80, 84)',
  subtle: 'rgb(136, 143, 146)',
  inverse: 'rgb(255, 255, 255)',
  link: 'rgb(0, 38, 100)',
}
export const border = {
  default: 'rgb(220, 223, 224)',
  subtle: 'rgb(235, 235, 235)',
  strong: 'rgb(136, 143, 146)',
}
export const action = {
  default: 'rgb(0, 38, 100)',
  hover: 'rgb(0, 16, 55)',
  subtle: 'rgb(240, 251, 255)',
}
export const success = {
  surface: 'rgb(239, 249, 237)',
  text: 'rgb(0, 90, 2)',
  border: 'rgb(143, 199, 138)',
  solid: 'rgb(0, 138, 7)',
}
export const warning = {
  surface: 'rgb(255, 243, 237)',
  text: 'rgb(136, 47, 3)',
  border: 'rgb(238, 168, 138)',
  solid: 'rgb(201, 80, 0)',
}
export const danger = {
  surface: 'rgb(255, 240, 239)',
  text: 'rgb(124, 6, 31)',
  border: 'rgb(234, 146, 148)',
  solid: 'rgb(184, 18, 55)',
}
export const info = {
  surface: 'rgb(233, 238, 247)',
  text: 'rgb(25, 51, 102)',
  border: 'rgb(128, 152, 194)',
  solid: 'rgb(46, 82, 153)',
}
